
import httpUtil from "@/assets/script/utils/http.util"
import { ref } from "vue"
import { useRoute } from "vue-router"
import { Toast } from "vant"
export default {
  setup() {
    const router = useRoute()
    const model = String(router.query.model || "MpeV2C3")
    const appId = String(router.query.appId || "1")
    const conentArr = ref([
      {
        img: "",
        name: "",
        corpus: "",
        describe: ""
      }
    ])
    const voiceControlArr = ref([
      {
        role: "",
        img: "",
        content: ""
      }
    ])
    const toast1 = Toast.loading({
      forbidClick: true,
      duration: 0
    })
    const toast2 = Toast.loading({
      forbidClick: true,
      duration: 0
    })
    // eslint-disable-next-line
    httpUtil.get("https://down.mpebedding.com/guide.json").then((res: any) => {
      conentArr.value = res[model]
      toast1.clear()
    })
    // eslint-disable-next-line
    httpUtil.get("https://down.mpebedding.com/voiceControl.json").then((res: any) => {
        voiceControlArr.value = res[appId]
        toast2.clear()
      })
    const hasChinese = (str: string) => {
      const chineseRegex = /[\u4e00-\u9fff]/
      return chineseRegex.test(str)
    }

    return {
      conentArr,
      hasChinese,
      voiceControlArr
    }
  }
}
